<template>
    <div class="p-3">
        <div class="row">
            <div class="col-lg-5">
                <div class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-alamat-email"></label>
                    <div class="col-lg-8">
                        <b-button variant="success" class="col-lg-4" @click="toggleKeyboard">Keyboard</b-button>
                    </div>
                </div>
            </div>
        </div>

        <Tiket :show="showTiketModal" :datum="tiketObj" :on-close="() => { showTiketModal = false; tiketObj = {}; }"/>
        <b-tabs content-class="mt-3">
            <b-tab title="Pendaftaran Pasien" @click="clearDataPasien" active>
                <div class="row">
                    <div class="col-lg-5">
                        <div class="form-group row pb-4">
                            <label class="col-lg-3 text-lg-end pt-2" for="input-no-rm">NIK</label>
                            <div class="col-lg-8">
                                <b-input-group>
                                    <input type="text" v-model="form.nik" @keyup.enter="searchPasien" class="form-control" id="input-no-rm" autocomplete="off" @focus="setInputKeyboard">

                                    <b-input-group-append>
                                        <b-button variant="success" @click="searchPasien"><i class="fa fa-search"></i></b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                
                                <small v-if="validation.nik" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">NIK harus diisi!</small>
                            </div>
                        </div>
                    </div>
                </div>

                <FormPasien v-if="data_pasien" :data_pasien="data_pasien" :no_rujukan="no_rujukan" :on-register-success="registerSuccess"/>
            </b-tab>
            <b-tab title="List Pendaftaran Online">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="form-group row pb-4">
                            <label class="col-lg-3 text-lg-end pt-2" for="input-tanggal-registrasi">Tanggal</label>
                            <div class="col-lg-8">
                                <input type="date" v-model="tanggal_registrasi" class="form-control" id="input-tanggal-registrasi" @change="getRegisters" @focus="setInputKeyboard">
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="form-group row pb-4">
                            <label class="col-lg-3 text-lg-end pt-2" for="input-nik-registrasi">NIK</label>
                            <div class="col-lg-8">
                                <input type="number" v-model="nik_registrasi" class="form-control" id="input-nik-registrasi" @change="getRegisters" @focus="setInputKeyboard">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div id="tabledata-regsters"></div>
                </div>
            </b-tab>
        </b-tabs>

        <vue-touch-keyboard :options="data_keyboard.options" v-if="data_keyboard.visible" :layout="data_keyboard.layout" :cancel="data_keyboard.hide" :accept="data_keyboard.accept" :input="data_keyboard.input" />
    </div>
</template>

<script>
import FormPasien from './FormPasien.vue'
import Tiket from './Tiket.vue'

export default {
    name: "Pendaftaran",
    components: {
        FormPasien,
        Tiket
    },
    data() {
        return {
            data_keyboard: {
                visible: false,
                layout: "normal",
                input: null,
                options: {
                    useKbEvents: false,
                    preventClickEvent: false
                }
            },
            form: {
                nik: '',
            },
            validation: {
                nik: false,
            },
            data_pasien: null,
            no_rujukan: [],
            registers: [],
            table: null,
            tanggal_registrasi: '',
            nik_registrasi: '',
            showTiketModal: false,
            tiketObj: {}
        }
    },
    created() {},
    methods: {
        toggleKeyboard() {
            this.data_keyboard.visible = !this.data_keyboard.visible
        },
        setInputKeyboard(e) {
            this.data_keyboard.input = e.target
        },
        clearDataPasien() {
            this.data_pasien = null
            this.form = {
                nik: '',
            }
        },
        searchPasien() {
            if (this.form.nik != '') {
                this.$isLoading(true)
                let uri = '/api/getpasien?nik=' + this.form.nik

                this.axios.get(uri).then(response => {
                    if (response.data.status) {
                        this.data_pasien = response.data.pasien
                        this.no_rujukan = response.data.no_rujukan ? [response.data.no_rujukan] : []
                    } else {
                        this.$swal.fire({
                            title: 'Pendaftaran Tidak Dapat Diproses',
                            text: response.data.msg,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });    
                    }
                    this.$isLoading(false)
                }).catch(error => {
                    this.$swal.fire({
                        title: 'Pendaftaran Tidak Dapat Diproses',
                        text: 'Terjadi error pada halaman ini, silahkan hubungin tim IT!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                    this.$isLoading(false)
                })
            }
        },
        getRegisters() {
            this.$isLoading(true)
            let uri = `/api/get-registers?tanggal=${this.tanggal_registrasi}&nik=${this.nik_registrasi}`

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.registers = response.data.registers

                let kategori_pasien = function (cell, formatterParams) {
                    let data = cell.getRow().getData()
                    let cat = data.Kategori
                    let kategori = ''

                    switch (cat) {
                        case '1':
                        case 1:
                            kategori = 'UMUM'
                            break;
                        case '2':
                        case 2:
                            kategori = 'BPJS'
                            break;
                        case '3':
                        case 3:
                            kategori = 'JAMINAN LAIN'
                            break;

                        default:
                            break;
                    }

                    return kategori
                }

                this.table = new Tabulator('#tabledata-regsters', {
                    layout:"fitColumns",
                    data: this.registers,
                    pagination: 'local',
                    paginationSize: 10,
                    paginationSizeSelector:[10, 25, 50, 100, true],
                    columns:[
                        {title: 'No. RM', field: 'Medrec', headerSort: false},
                        {title: 'Kode Booking', field: 'Regno', headerSort: false},
                        {title: 'No. Antrian Loket', field: 'antrean_pendaftaran.nomor_antrean', headerSort: false},
                        {title: 'Tanggal Pendaftaran', field: 'Regdate', formatter:"datetime", formatterParams:{
                            inputFormat:"YYYY-MM-DD",
                            outputFormat:"DD/MM/YYYY",
                            invalidPlaceholder:"(invalid date)",
                        }, headerSort: false},
                        {title: 'Jam Pelayanan', field: 'antrean_pendaftaran.jam_jadwal_dokter', headerSort: false},
                        {title: 'Kategori', field: 'Kategori', formatter: kategori_pasien, headerSort: false},
                        {title: 'Poli', field: 'poli.NMPoli'},
                    ],
                    initialSort:[
                        {column: 'Regno', dir:"asc"}, //sort by this first
                    ]
                })

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        registerSuccess(data) {
            this.tiketObj = data
            this.showTiketModal = true
            this.data_pasien = null
        }
    }
}
</script>
